export enum ValueTypeGroupEnum {
    VehicleMake=221,
    VehicleType=220,
    StatementPeriod=236,
    PaymentType=237,
    ReasonType=46,
    ReactivateType=222,
    StatusType=207
}
export enum UserCategory
{
    Corporate = '6301',
    Retail='6304',
}
export enum UserSubCategory{
    FleetPostpaid = '6401',
    Retail = '6402',
    ClusterBusOwner = '6403',
    FleetPrepaidOwner = '6404',
    PartnerCustomer = '6405'
}
export enum CardStatus {
    ACTIVE = 801,
    BLOCKED = 802,
    EXPIRED = 803,
    INACTIVE = 804,
    HotlistTemporary = 805,
    HotlistPermanent = 806,
    Pending = 807,
}
export enum LedgerType{
    CreditLedger=23801,
    CCMSLedger=23802
}
export enum TransactionType
{
    CCMSToCard=419,
    CardToCCMS=420,
    CardDebit=421,
    CardCredit=422
}
export enum PartnerCode{
    PayTM = 45,
    MobiKwik = 46,
    mRUPEE = 47,
    CitrusPay = 48,
    SBI = 49,
    OXIGEN = 50,
    Freecharge = 51,
    ATOM = 53,
    OLAMoney = 62,

    //UAT
    //PayZapp = 63,
    //AirtelMoney = 66,
    //HDFC = 67,
    SBI_Net_Banking = 68,
    IGL = 68,
    //IdeaMoney = 70,
    BharatQRCODE = 71,
    CommonQRCode = 72,

    //PROD
    TMW = 63,
    AirtelBank = 64,
    PayU = 65,
    Intex = 66,
    IdeaMoney = 67,
}   

export enum LocationType
    {
        Country = 6201,
        State = 6202,
        City = 6203,
    }

    export enum Country
    {
        India = 1
    }

    export enum CustomerCategoryType
    {
        Corporate = 6301,
        Employee = 6302,
        Agency = 6303,
        Individual = 6304,
    }

    export enum TransactionSourceType
    {
        EDC = 9701,
        ATM = 9702,
        Mobile = 9703,
        ecommerce = 9704,
        CashRegister = 9705
    }

    export enum TransactionSchemaMasterParamterEnum
    {
        MMID = 1,
        MTID = 2,
        TTP = 3,
        PAN = 4,
        TBID = 5,
        AMT = 6,
        RRN = 7,
        TXNDT = 8,
        TRANSACTIONDATEPART = 9,
        TRANSACTIONTIMEPART = 10,
        INV = 11,
        MRN = 12,
        MAL1 = 13,
        MERCHANTCITY = 14,
        MERCHANTIMAGE = 15,
        ACQUIRERID = 16,
        AQN = 17,
        ACQUIRERIMAGE = 18,
        IID = 19,
        ISSUERNAME = 20,
        ISSUERIMAGE = 21,
        OTP = 22,
        HSN = 23,
        SWVERSION = 24,
        PTYP = 25,
        PAYID = 26,
        RSPC = 27,
        RSPM = 28,
        IAC = 29,
        TXNID = 30,
        TERMINALPIN = 31,
        MPIN = 32,
        TOTALTXNAMOUNT = 33,
        TOTALTXNCOUNT = 34,
        TOTALCREDITAMOUNT = 35,
        TOTALCREDITCOUNT = 36,
        TOTALDEBITAMOUNT = 37,
        TOTALDEBITCOUNT = 38,
        TOTALENQUIRYCOUNT = 39,
        COUPONCODE = 40,
        COUPONDESCRIPTION = 41,
        COUPONIMAGE = 42,
        SUR = 43,
        TAMT = 44,
        MAL2 = 45,
        MAL3 = 46,
        FLN1 = 47,
        FLN2 = 48,
        FLN3 = 49,
        FLN4 = 50,
        FLN5 = 51,
        SCID = 52,
        LINE = 53,
        SPACE = 54,
        WAMT = 55,
        MBNO = 56,
        BTID = 57,
        BMID = 58,
        RFU1 = 59,
        RFU2 = 60,
        RFU3 = 61,
        RFU4 = 62,
        RFU5 = 63,
        RFU6 = 64,
        RFU7 = 65,
        RFU8 = 66,
        RFU9 = 67,
        RFU10 = 68,
    }
    
    export enum PaymentModeType
    {
        Cheque = 23701,
        DemandDraft = 23702,
        CashUpload = 23703,
        NEFT = 23704,
        RTGS =23705
    }
    export enum MemberStatus
    {
        Pending = 1106,
        Active = 1101,
        Blocked = 1102,
        Inactive = 1103,
        HotlistTemporary = 1104,
        HotlistPermanent = 1105,
        Rejected=1107
    }
    export enum DocType
    {
        Pancard=23001,
        AadharCard=23002,
        GSTNumber=23003
    }
    export enum StatementCycle
    {
        TenDays=23601,
        FifteenDays=23602,
        ThirtyDays=23603
    }

    export enum OfficeCategory
    {
        HeadOffice=6801,
        ZonalOffice=6802,
        RegionalOffice=6803
    }
    export enum ControlNames {

        MerchantTransactions ='MerchantTransactions',
        Tickets ='Tickets',
        Helpdesk  ='Helpdesk',
        Reports  = 'Reports',
        Dashboard  = 'Dashboard'
        
    }

    export enum CustomerSubTypes
    {
        FleetOwner = 6401,
        RetailCustomer = 6402,
        ClusterBusOwner = 6403
    }

    export enum HotlistAction
    {
        Temporary = 4501,
        Permanent = 4502,
        Reactivate = 4503,
    }
    export enum EntityType
    {
        System = 100,
        Network = 101,
        Merchant = 102,
        Outlet = 103,
        Terminal = 104,
        Customer = 105,
        Card = 106,
        Manufacture = 107,
        Partner = 108,
        Program = 109,
        Request = 110,
        Institute = 111,
        Acquirer = 112
    }

    export enum HotlistReason
    {
        CardLost = 4601,
        CardDamage = 4602,
        AccountClosure = 4603,
        Other = 4604,
        CardMisPlaced = 4605,
        CardNotinUse = 4606

    }
    export enum ServiceRequestType
    {
        ReissueCard = 18701,
        RenewCard = 18702,
        TxnInquiry = 18703,
        TemporaryHotlist = 18704,
        ReActivateCard = 18705,
        BalanceInquiry = 18706,
        ResetPassword = 18707,
        PINChange = 18708,
        PermanentHotlist = 18710,
        Miscellaneous = 18711,
        Activate = 18712,
        Block = 18713
    }


// WEBPACK FOOTER //
// ./src/app/common/app-enum.ts